import React, { useEffect, useState } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { UPLOADS_URL } from "../config";
import "../../style/tareasPadres.css";

const TareasPadre = () => {
  const { token } = useAuth();

  const [estudiantes, setEstudiantes] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingPeriodos, setLoadingPeriodos] = useState(true);
  const [error, setError] = useState("");

  /* =============================
      🔹 CARGAR PERIODOS
  ============================== */
  useEffect(() => {
    const fetchPeriodos = async () => {
      try {
        setLoadingPeriodos(true);

        const res = await axios.get("/padre/periodos");
        const data = res.data || [];

        setPeriodos(data);

        if (data.length > 0) {
          setSelectedPeriodo(data[0].id.toString());
        }
      } catch (err) {
        console.error("Error cargando períodos:", err);
        setError("No se pudieron cargar los períodos escolares.");
      } finally {
        setLoadingPeriodos(false);
      }
    };

    if (token) fetchPeriodos();
  }, [token]);

  /* =============================
      🔹 CARGAR TAREAS
  ============================== */
  useEffect(() => {
    if (!selectedPeriodo || !token) return;

    const fetchTareas = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await axios.get("/padre/tareas", {
          params: { periodoId: selectedPeriodo },
        });

        setEstudiantes(res.data || []);
      } catch (err) {
        console.error("Error cargando tareas:", err);
        setError("Ocurrió un error al cargar las tareas.");
        setEstudiantes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTareas();
  }, [selectedPeriodo, token]);

  /* =============================
      🔹 FORMATO FECHA CORRECTO
  ============================== */
  const formatYear = (date) => {
    if (!date) return "";
    return new Date(date).getFullYear(); // ✅ CORRECTO
  };

  const formatDate = (date) => {
    if (!date) return "Sin fecha";

    return new Date(date).toLocaleString("es-CO", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const getEstadoRespuesta = (respondio) => {
    return respondio
      ? { texto: "Entregada", clase: "respondio" }
      : { texto: "Pendiente", clase: "no-respondio" };
  };

  /* =============================
      🔹 UI
  ============================== */
  return (
    <div className="tareas-padre-wrapper">
      <header className="tareas-header">
        <h2>📢 Seguimiento de Tareas</h2>
        <p className="subtitle">
          Supervise las actividades académicas de sus hijos
        </p>
      </header>

      {/* PERÍODO */}
      <div className="periodo-select-container">
        <label>Período Académico:</label>

        {loadingPeriodos ? (
          <span>⏳ Cargando...</span>
        ) : (
          <select
            value={selectedPeriodo}
            onChange={(e) => setSelectedPeriodo(e.target.value)}
          >
            {periodos.map((p) => (
              <option key={p.id} value={p.id}>
                {p.nombre} ({formatYear(p.fecha_inicio)})
              </option>
            ))}
          </select>
        )}
      </div>

      <hr />

      {/* ESTADOS */}
      {loading && <p>⏳ Cargando tareas...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && estudiantes.length === 0 && !error && (
        <p>No hay tareas registradas.</p>
      )}

      {/* LISTA */}
      <div className="grid-estudiantes-tareas">
        {estudiantes.map((est) => (
          <div key={est.estudiante_id} className="padre-card">
            <h3>
              👨‍🎓 {est.nombres_estudiante} {est.apellidos_estudiante}
            </h3>

            {(!est.tareas || est.tareas.length === 0) ? (
              <p>Sin tareas</p>
            ) : (
              est.tareas.map((t) => {
                const estado = getEstadoRespuesta(t.respondio);

                return (
                  <div key={t.id} className="tarea-item">
                    <div>
                      <strong>{t.title}</strong>
                      <span className={estado.clase}> {estado.texto}</span>
                    </div>

                    <p>
                      📚 {t.materia} | 👨‍🏫 {t.profesor}
                    </p>

                    <p>{t.description}</p>

                    <p>📅 {formatDate(t.due_date)}</p>

                    {t.archivo && (
                      <a
                        href={`${UPLOADS_URL}/tasks/${t.archivo}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        📎 Descargar
                      </a>
                    )}
                  </div>
                );
              })
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TareasPadre;
